/**
 * 구글 로그인 창 주소 (2026-10-22 대표 지시) — 운영 주소에서는 사이트 자기 주소를 Firebase authDomain 으로 쓴다.
 * 로그인 창·구글 "○○(으)로 이동" 에 trinitymap2026.firebaseapp.com 대신 www.maptest.kr 이 보인다.
 * /__/auth/* · /__/firebase/* 는 next.config.ts rewrites 가 Firebase 기본 도메인으로 넘긴다.
 * 여기 없는 주소 (localhost · 미리보기 배포) 는 기존 env 값 그대로 (그 주소는 구글 OAuth 리다이렉트 등록이 없어서).
 */
export const SELF_AUTH_DOMAIN_HOSTS: ReadonlySet<string> = new Set(["www.maptest.kr"]);

export function pickAuthDomain(hostname: string | null, host: string | null, fallback: string | undefined): string | undefined {
  return hostname && host && SELF_AUTH_DOMAIN_HOSTS.has(hostname) ? host : fallback;
}
